
import React, {useEffect, useState} from "react";
import { Switch, Route, HashRouter as Router, Link, Redirect } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "./App.css";
import {
  Navbar,
  Nav,
  NavDropdown,
  Form,
  FormControl,
  Button,
  Dropdown
 } from "react-bootstrap";

import history from './history';

import Home from "./components/home";
import News from "./components/news";
import Teachers from "./components/teachers";
import Students from "./components/students";

import Register from "./components/register";
import RegistrationForm from "./components/registrationForm";
import RegistrationFormSpecial from "./components/registrationForm/register-special";
import RegistrationFormKindergarten from "./components/registrationForm/register-kindergarten";

import Login from './components/login/Login';

import AuthService from './services/Auth/AuthService';
import logo from './images/logo.jpg'
import useToken from './useToken';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import httpCommon from './http-common';
import { useHistory,useLocation} from "react-router-dom";

const Navigation = ({user, setToken}) => {
  
  const logout = async () => {
    await AuthService.logoutUser();
    
    window.location.href="/app"
    setToken(null);
  }

  return (
    <Navbar bg="primary" variant="dark" expand="md">
      <Navbar.Brand href="#home"><img alt="logo" className="logo" src={require('./images/logo.png').default}/></Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="container-fluid">
          <Nav.Item>
            <Nav.Link as={Link} to="/home">Home</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/news">News</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/teachers">Teachers</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/students">Students</Nav.Link>
          </Nav.Item>
        </Nav>
      </Navbar.Collapse>
      <Dropdown style={{padding: 0, margin: 20, borderWidth: 0}}>
        <Dropdown.Toggle id="dropdown-basic" style={{padding: 0, margin: 0, borderWidth: 0}}>
          <div style={{textAlign: 'center'}}><FontAwesomeIcon icon={faUser}/></div>
          <div style={{display: 'flex', flexDirection: 'row', paddingHorizontal: 5}}>
            <div style={{textAlign: 'center'}}>{user?.email}</div>
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item onClick={logout}>Logout</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </Navbar>
  )
}

function App() {
  //const { token, setToken } = AuthService.useToken();
  const { token, setToken } = useToken();
  const [register, setRegister] = useState(false);
  const [registrationForm, setRegistrationForm] = useState(false);
  const [reset, setReset] = useState(false);
  const [verifyStatus, setVerifyStatus] = useState(false);
  const [verifySource, setVerifySource] = useState();

  const search = useLocation().search;
  const pathname = useLocation().pathname;
  
  useEffect(() => {
    document.title = "Cool Kids English Parent Portal"

    const incomingRegistrationForm = new URLSearchParams(search).get('regform');
    console.log(pathname);
    setRegistrationForm(incomingRegistrationForm);

    const incomingVerifyStatus = new URLSearchParams(search).get('verifyStatus');
    const incomingVerifySource = new URLSearchParams(search).get('verifySource');
    setVerifyStatus(incomingVerifyStatus);
    setVerifySource(incomingVerifySource);

  }, []);

  const renderFormResponse = () => {
    return (
      <div>
        <Navbar bg="primary" variant="dark" expand="md">
          <Navbar.Brand href="#home"><img alt="logo" className="logo" src={require('./images/logo.png').default}/></Navbar.Brand>
        </Navbar>
        <div><h2>Überprüfung erfolgreich</h2>Ihre Registrierung ist nun abgeschlossen.</div>
        <hr/>
      </div>
    )
  }

  if (verifyStatus && verifySource === 'form') {
    return renderFormResponse();
  } else if (registrationForm) {
    if (registrationForm === 'sp') {
      return <RegistrationFormSpecial setRegister={setRegister}/>
    } else if (registrationForm === 'kg') {
      return <RegistrationFormKindergarten setRegister={setRegister}/>
    } else {
      return <RegistrationForm setRegister={setRegister}/>
    }
  } else if (register) {
    return <Register setRegister={setRegister}/>
  } else if(!token) {
    return <div>down for maintenance</div>//<Login history={history} setToken={setToken} setRegister={setRegister}/>
  }

  return (
    <div className="App">
      <title>Cool Kids English Parent Portal</title>
      <Router history={history}>
        <Navigation setToken={setToken} user={token}/>
          <Switch>
              <Route
                  exact path={[`/`, '/app']}
                  render={() => {
                      return (
                        <Redirect to='/home'/>
                      )
                  }}
              />
              <Route exact path={`/home`} component={Home} />
              <Route exact path={`/news`} component={News} />
              <Route exact path={`/teachers`} component={Teachers} />
              <Route exact path={`/students`} component={Students} />
          </Switch>
          </Router>
    </div>
  );
}

export default App;